import * as Types from '../../../../@types/graphql-types';

import gql from 'graphql-tag';
import { TitleOfferFragmentDoc } from '../../../buybox/graphql/fragments/Offer.fragment';
export type GetUserLibraryQueryVariables = Types.Exact<{
	country: Types.Scalars['Country']['input'];
	language: Types.Scalars['Language']['input'];
	platform?: Types.Platform;
}>;

export type GetUserLibraryQuery = {
	__typename?: 'Query';
	getUserLibrary: {
		__typename?: 'UserLibraryPayload';
		items: Array<{
			__typename?: 'UserLibraryItem';
			title: string;
			slug: string;
			type: string;
			ownership: string;
			availableFrom?: string | null;
			availableTo?: string | null;
			expiry?: string | null;
			playbackProgress?: { __typename?: 'PlaybackProgress'; position: number; runtime: number } | null;
			node?:
				| {
						__typename: 'Movie';
						id: string;
						objectType: Types.ObjectType;
						objectId: number;
						content: {
							__typename?: 'MovieContent';
							fullPath: string;
							title: string;
							originalTitle: string;
							backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
						};
						offers: Array<{
							__typename?: 'Offer';
							id: string;
							presentationType: Types.PresentationType;
							monetizationType: Types.MonetizationType;
							newElementCount?: number | null;
							retailPrice?: string | null;
							retailPriceValue?: number | null;
							userLocalCurrency?: string | null;
							retailPriceConverted?: string | null;
							currency?: string | null;
							lastChangeRetailPriceValue?: number | null;
							type: Types.OfferType;
							country: any;
							standardWebURL?: string | null;
							preAffiliatedStandardWebURL?: string | null;
							streamUrl?: string | null;
							streamUrlExternalPlayer?: string | null;
							elementCount?: number | null;
							availableTo?: any | null;
							availableFromTime?: any | null;
							availableToTime?: any | null;
							subtitleLanguages: Array<any>;
							videoTechnology: Array<Types.VideoTechnology>;
							audioTechnology: Array<Types.AudioTechnology>;
							audioLanguages: Array<any>;
							updatedAt?: any | null;
							mediaDealId?: number | null;
							package: {
								__typename?: 'Package';
								id: string;
								packageId: number;
								clearName: string;
								shortName: string;
								technicalName: string;
								icon: string;
								iconWide: string;
								maskReferrer?: boolean | null;
								planOffers: Array<{
									__typename?: 'PackagePlanOffer';
									title?: string | null;
									retailPrice?: string | null;
									isTrial?: boolean | null;
									durationDays?: number | null;
									retailPriceValue?: number | null;
									retailPriceConverted?: string | null;
									children: Array<{
										__typename?: 'PackagePlanOffer';
										title?: string | null;
										retailPrice?: string | null;
										isTrial?: boolean | null;
										durationDays?: number | null;
										retailPriceValue?: number | null;
									}>;
								}>;
							};
							plans: Array<{
								__typename?: 'PackagePlanOffer';
								title?: string | null;
								retailPrice?: string | null;
								isTrial?: boolean | null;
								durationDays?: number | null;
								retailPriceValue?: number | null;
								retailPriceConverted?: string | null;
								children: Array<{
									__typename?: 'PackagePlanOffer';
									title?: string | null;
									retailPrice?: string | null;
									isTrial?: boolean | null;
									durationDays?: number | null;
									retailPriceValue?: number | null;
								}>;
							}>;
						}>;
				  }
				| {
						__typename: 'Show';
						id: string;
						objectType: Types.ObjectType;
						objectId: number;
						content: {
							__typename?: 'ShowContent';
							fullPath: string;
							title: string;
							originalTitle: string;
							backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
						};
						offers: Array<{
							__typename?: 'Offer';
							id: string;
							presentationType: Types.PresentationType;
							monetizationType: Types.MonetizationType;
							newElementCount?: number | null;
							retailPrice?: string | null;
							retailPriceValue?: number | null;
							userLocalCurrency?: string | null;
							retailPriceConverted?: string | null;
							currency?: string | null;
							lastChangeRetailPriceValue?: number | null;
							type: Types.OfferType;
							country: any;
							standardWebURL?: string | null;
							preAffiliatedStandardWebURL?: string | null;
							streamUrl?: string | null;
							streamUrlExternalPlayer?: string | null;
							elementCount?: number | null;
							availableTo?: any | null;
							availableFromTime?: any | null;
							availableToTime?: any | null;
							subtitleLanguages: Array<any>;
							videoTechnology: Array<Types.VideoTechnology>;
							audioTechnology: Array<Types.AudioTechnology>;
							audioLanguages: Array<any>;
							updatedAt?: any | null;
							mediaDealId?: number | null;
							package: {
								__typename?: 'Package';
								id: string;
								packageId: number;
								clearName: string;
								shortName: string;
								technicalName: string;
								icon: string;
								iconWide: string;
								maskReferrer?: boolean | null;
								planOffers: Array<{
									__typename?: 'PackagePlanOffer';
									title?: string | null;
									retailPrice?: string | null;
									isTrial?: boolean | null;
									durationDays?: number | null;
									retailPriceValue?: number | null;
									retailPriceConverted?: string | null;
									children: Array<{
										__typename?: 'PackagePlanOffer';
										title?: string | null;
										retailPrice?: string | null;
										isTrial?: boolean | null;
										durationDays?: number | null;
										retailPriceValue?: number | null;
									}>;
								}>;
							};
							plans: Array<{
								__typename?: 'PackagePlanOffer';
								title?: string | null;
								retailPrice?: string | null;
								isTrial?: boolean | null;
								durationDays?: number | null;
								retailPriceValue?: number | null;
								retailPriceConverted?: string | null;
								children: Array<{
									__typename?: 'PackagePlanOffer';
									title?: string | null;
									retailPrice?: string | null;
									isTrial?: boolean | null;
									durationDays?: number | null;
									retailPriceValue?: number | null;
								}>;
							}>;
						}>;
				  }
				| null;
		}>;
		plans: Array<{ __typename?: 'PlanAccess'; planId: number; expiry?: string | null }>;
	};
};

export const GetUserLibraryDocument = gql`
	query GetUserLibrary($country: Country!, $language: Language!, $platform: Platform! = WEB) {
		getUserLibrary {
			items {
				title
				slug
				type
				ownership
				availableFrom
				availableTo
				expiry
				playbackProgress {
					position
					runtime
				}
				node {
					__typename
					... on MovieOrShow {
						id
						objectType
						objectId
						content(country: $country, language: $language) {
							fullPath
							title
							originalTitle
							backdrops {
								backdropUrl
							}
						}
						offers(country: $country, platform: $platform) {
							...TitleOffer
						}
					}
				}
			}
			plans {
				planId
				expiry
			}
		}
	}
	${TitleOfferFragmentDoc}
`;
